<template>
  <div>
    <table class="dep-table details-table" style="width: 100%; font-size: 13px; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Sn</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Code</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Item</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Qty.</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Unit</th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, idx) in saleInvoiceDelivery?.invoice_delivery_details" :key="idx">
          <tr>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ idx + 1 }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.code }}</td>
            <td style="border:1px solid #E0E0E0;">{{ row.product?.name }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.qty }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.unit?.name }}</td>
          </tr>
        </template>
      </tbody>

    </table>
  </div>
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';

export default {
  name: "slsSaleOrderDetailsTable",
  data() {
    return {
      saleInvoiceDelivery: null,
      
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    convertNumberToWords,
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;
    this.$store.dispatch('getInvSalesInvoiceDeliveryById', id)
      .then((res) => {
        this.saleInvoiceDelivery = res;
      })
  },
};  

</script>
